import { useSelector } from "react-redux";
import { IDocumentView } from "../../components/DocumentView/type";
import { selectDocumentView, selectDrawer, selectSplitView } from "./selector";

export const useLayoutSplitView = (): boolean => useSelector(selectSplitView);
export const useDrawer = (): boolean => useSelector(selectDrawer);
export const useDocumentView = (): IDocumentView => useSelector(selectDocumentView);
